export const ABORT_EXCEPTION_NAME = 'AbortError';
export const ABORT_EXCEPTION_DESCRIPTION = 'Aborted';

export const createAbortException = () =>
    new DOMException(ABORT_EXCEPTION_DESCRIPTION, ABORT_EXCEPTION_NAME);

/**
 * Make abortable promise using signal
 */
export function makePromiseAbortable<T>(promise: Promise<T>, signal: AbortSignal): Promise<T> {
    const exception = createAbortException();
    if (signal.aborted) return Promise.reject(exception);

    let resultReject: (e: DOMException) => void;

    const signalPromise = new Promise((_, reject) => {
        resultReject = reject;
    });

    const abortHandler = (): void => resultReject(exception);

    signal.addEventListener('abort', abortHandler);

    return Promise.race([promise, signalPromise]).finally(() =>
        signal.removeEventListener('abort', abortHandler)
    ) as Promise<T>;
}

export const isAbortException = (error?: any) =>
    error?.name === ABORT_EXCEPTION_NAME && error?.message === ABORT_EXCEPTION_DESCRIPTION;
